import defaultMessages from './messages';

const values = Object.values(defaultMessages);

// Recursively maps the messages.ts file to a keyvalue pair
const getKeyValue = (data: any): any => {
  if (data.id && data.defaultMessage) {
    return { [data.id]: data.defaultMessage };
  } else {
    return Object.values(data).reduce((previous: any, current) => {
      return { ...previous, ...getKeyValue(current) };
    }, {});
  }
};

const messages = getKeyValue(values);

export default messages;
